<div class="rich-text-content">
  <ng-container *ngFor="let element of parsedElements">
    
    <!-- Text elements (inline) -->
    <span *ngIf="element.type === 'text'">{{ element.content }}</span>
    
    <!-- Image elements (full width on new line using Bootstrap card) -->
    <div *ngIf="element.type === 'image'" class="card w-100 shadow-sm border-0 mt-2">
      <img 
        [src]="element.url" 
        [alt]="element.title" 
        [title]="element.title"
        class="card-img-top"
        (click)="onImageClick(element.url!, element.title!)"
      />
    </div>
    
    <!-- Link elements (inline) -->
    <span 
      *ngIf="element.type === 'link'" 
      [title]="element.title"
      (click)="onLinkClick(element.url!, element.title!)"
      style="cursor: pointer; color: #007bff; text-decoration: underline;"
    >
      {{ element.content }}
    </span>
    
    <!-- Video elements (full width on new line using Bootstrap card) -->
    <div *ngIf="element.type === 'video'" class="card w-100 shadow-sm border-0 mt-2">
      <div class="card-body p-0">
        <video 
          [src]="element.url" 
          [title]="element.title"
          class="w-100"
          controls
          (click)="onVideoClick(element.url!, element.title!)"
          style="cursor: pointer;"
        >
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
    
    <!-- Audio elements (full width on new line using Bootstrap card) -->
    <div *ngIf="element.type === 'audio'" class="card w-100 shadow-sm border-0 mt-2">
      <div class="card-body p-2">
        <audio 
          [src]="element.url" 
          [title]="element.title"
          class="w-100"
          controls
          (click)="onAudioClick(element.url!, element.title!)"
        >
          Your browser does not support the audio tag.
        </audio>
      </div>
    </div>
    
    <!-- PDF elements (inline link like other links) -->
    <span 
      *ngIf="element.type === 'pdf'" 
      [title]="element.title"
      (click)="onPdfClick(element.url!, element.title!)"
      style="cursor: pointer; color: #007bff;"
      class="text-decoration-none"
    >
      <i class="fa fa-file-pdf-o me-1"></i>
      <span *ngIf="!pdfLoading[element.title!]">{{ element.content }}</span>
      <span *ngIf="pdfLoading[element.title!]">
        <i class="fa fa-spinner fa-spin me-1"></i>
        Loading...
      </span>
    </span>
    
  </ng-container>
</div>
